class LocationInterface {
    constructor(params) {
        this._initLocationTooltip = this._initLocationTooltip.bind(this);
        this._detectLocation = this._detectLocation.bind(this);
        this._initLocationModalContent = this._initLocationModalContent.bind(this);
        this._showLocationDefaults = this._showLocationDefaults.bind(this);
        this._showLocationSearchResults = this._showLocationSearchResults.bind(this);
        this._showLocationEmpty = this._showLocationEmpty.bind(this);
        this._handleClickLocationDetect = this._handleClickLocationDetect.bind(this);
        this._handleClickLocationSubmit = this._handleClickLocationSubmit.bind(this);
        this._handleChooseLocation = this._handleChooseLocation.bind(this);
        this._initRadiosList = this._initRadiosList.bind(this);
        this._handleLocationDetectError = this._handleLocationDetectError.bind(this);
        this._defaultLocations = window.globalHeaderData.topCity || [];
        this._userCity = window.globalHeaderData.userCity || [];
        this._skipTooltip = !!params.skipTooltip;
        if (params.element) {
            this._pinNode = params.element;
            this.initLocationPin(this._pinNode);
        }
    }

    initLocationPin(node) {
        if (this._userCity.type === 'auto' && !this._skipTooltip) {
            this._initLocationTooltip(node);
        } else {
            node.addEventListener('click', event => {
                event.preventDefault();
                this._showLocationModal();
            })
        }
    }

    _initLocationTooltip(node) {
        const $pin = $(node);
        const locationSubmitTooltip = document.createElement('div');
        locationSubmitTooltip.classList.add('loc-q');
        locationSubmitTooltip.innerHTML =
            `<div class="loc-q__title">Ваш город <span class="loc-q__val">${this._userCity.name}</span>?</div>
                <div class="loc-q__text">
                    Укажите ваш&nbsp;город, чтобы увидеть доступные способы доставки, а&nbsp;также сроки и&nbsp;стоимость.
                </div>`;

        const btns = document.createElement('div');
        btns.classList.add('loc-q__btns');

        const btnSubmit = document.createElement('button');
        btnSubmit.classList.add('loc-q__btn', 'ui-btn', 'ui-btn_red', 'ui-btn_h40');
        btnSubmit.innerHTML = `<span class="ui-btn__title">Всё верно</span>`;

        btnSubmit.addEventListener('click', this._handleClickLocationSubmit);
        btns.appendChild(btnSubmit);

        const btnChoose = document.createElement('button');
        btnChoose.classList.add('loc-q__btn', 'ui-btn', 'ui-btn_white-grey', 'ui-btn_h40');
        btnChoose.innerHTML = `<span class="ui-btn__title">Выбрать город</span>`;

        btnChoose.addEventListener('click', event => {
            event.preventDefault();
            $pin.tooltipster('close');
            this._showLocationModal();
        });
        btns.appendChild(btnChoose);

        const handleScroll = function(event) {
            $pin.tooltipster('close');
        }

        locationSubmitTooltip.appendChild(btns);

        $pin.tooltipster({
            arrow: false,
            content: locationSubmitTooltip,
            contentAsHTML: true,
            delay: 300,
            debug: false,
            functionAfter: function(instance, helper) {
                document.removeEventListener('scroll', handleScroll);
                const simplebarMenuInstance = SimpleBar.instances.get(document.querySelector('[data-simplebar]'));
                if (simplebarMenuInstance) {
                    simplebarMenuInstance.getScrollElement().removeEventListener('scroll', handleScroll);
                }
            },
            functionBefore: function(instance, helper) {
                document.addEventListener('scroll', handleScroll, {once: true});
                const simplebarMenuInstance = SimpleBar.instances.get(document.querySelector('[data-simplebar]'));
                if (simplebarMenuInstance) {
                    simplebarMenuInstance.getScrollElement().addEventListener('scroll', handleScroll, {once: true});
                }
            },
            interactive: true,
            maxWidth: 373,
            side: 'bottom',
            theme: 'tooltipster-unpadded',
            trackOrigin: true,
            trigger: 'custom',
            triggerOpen: {
                click: true,
                tap: true
            },
            triggerClose: {
                click: true,
                tap: true
            },
            viewportAware: true,
            zIndex: 999999
        })
    }

    _getLocationListHTML = function(items) {
        let listHTML = `<div class="ui-radio-list">`;
        items.forEach((element, index) => {
            listHTML += `<div class="ui-radio-list__item">
                                <div class="ui-radio">
                                    <input type="radio" class="ui-radio__input" id="location${index}" name="location" value="${element.id || ''}" data-name-short="${element.nameShort || element.name}">
                                    <label for="location${index}" class="ui-radio__label">
                                        <div class="loc-search__city">${element.name || ''}</div>
                                        <div class="loc-search__region">${element.region || ''}</div>
                                    </label>
                                </div>
                            </div>`;
        })
        listHTML += `</div>`;
        return listHTML;
    };

    _getLocationModalHTML = function(itemsHTML = '') {
        return `<div id="modalLoc" class="modal-location" style="display: none;">
                        <div class="modal-container">
                            <div class="modal-header-mobile">
                                <div class="modal-header-mobile__inner">
                                    <div class="modal-header-mobile__text">Выберите город</div>
                                </div>
                            </div>
                            <div class="modal-content">
                                <div class="modal-content__inner js-modal-content-inner">
                                    <div class="modal-location-content">
                                        <div class="modal-header-desktop">Выберите город</div>
                                        
                                        <div class="loc-search modal-location__search js-loc-search">
                                            <div class="ui-input-custom ui-input-custom_search_right">
                                                <div class="ui-input-custom__box">
                                                    <input class="ui-input-custom__input js-loc-search__input" type="text" placeholder="Ваш город" maxlength="100">
                                                </div>
                                            </div>
                                            
                                            <div class="loc-search__check">
                                                <a href="#" class="link-txt _red _t-semibold js-loc-search__auto">Определить автоматически</a>
                                            </div>
                                            
                                            <div class="loc-search__radios js-loc-search__radios">${itemsHTML}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;
    };

    _showLocationModal() {
        const itemsHTML = this._getLocationListHTML(this._defaultLocations);
        const modalLocHTML = this._getLocationModalHTML(itemsHTML);

        $(modalLocHTML).iModalOpen({
            afterLoad: this._initLocationModalContent
        });
    }

    _handleClickLocationDetect(event) {
        event.preventDefault();
        this._detectLocation();
    }

    _handleChooseLocation(event) {
        this._sendLocationValue(event.target.value, event.target.dataset.nameShort);
    }

    _handleClickLocationSubmit(event) {
        event.preventDefault();
        this._sendLocationValue(this._userCity.kladrId, this._userCity.name);
    }

    _handleLocationDetectError(error) {
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('loc-search__check-error');
        errorMessage.innerText = 'Не удалось определить местоположение автоматически';
        this._btnAuto.insertAdjacentElement('afterend', errorMessage);
        this._btnAuto.remove();
        setTimeout(()=>{
            errorMessage.remove();
        }, 5000);
    }

    _initLocationModalContent(instance, current) {
        const searchElement = instance.current.$content[0].querySelector('.js-loc-search');
        if (searchElement) {
            this._btnAuto = searchElement.querySelector('.js-loc-search__auto');
            this._searchRadiosList = searchElement.querySelector('.js-loc-search__radios');
            this._searchRadiosError = searchElement.querySelector('.js-loc-search__error');
            this._searchLocationInput = searchElement.querySelector('.js-loc-search__input');
            this._searchLocationLastValue = null;
            if (this._btnAuto) {
                this._btnAuto.addEventListener('click', this._handleClickLocationDetect);
            }

            if (this._searchRadiosList) {
                this._initRadiosList();
            }

            if (this._searchLocationInput) {
                this._searchLocationInput.addEventListener('input', event => {
                    const value = event.target.value;
                    this._searchLocationLastValue = value;

                    if (value !== '') {
                        globalFunctions.delay(() => {
                            if (this._searchLocationLastValue === value) {
                                const dadata = new Dadata({
                                    apiKey: DADATA_TOKEN
                                });
                                const request = dadata.getAddressByQuery({
                                    query: value,
                                    from_bound: {'value': 'city'},
                                    to_bound: {'value': 'settlement'},
                                    // restrict_value: true,
                                    count: 100
                                });
                                
                                document.dispatchEvent(new CustomEvent('ab.analytics.event', {
                                    bubbles: true,
                                    cancelable: true,
                                    detail: {
                                        eventCode: 'dadataRequestSent',
                                        type: 'headerLocationSuggest',
                                    }
                                }));

                                request
                                    .then(response => {
                                        if (this._searchLocationLastValue === value) {
                                            if (response.hasOwnProperty('suggestions') && response.suggestions.length > 0) {
                                                this._showLocationSearchResults(response.suggestions);
                                            } else {
                                                this._showLocationEmpty();
                                            }
                                        }
                                    })
                                    .catch(error => console.log("error", error));
                            }
                        }, 750)();
                    } else {
                        this._showLocationDefaults();
                    }
                });
            }
        }
    }

    _detectLocation() {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const dadata = new Dadata({apiKey: DADATA_TOKEN});
                const request = dadata.getAddressByCoords({
                    lat: position.coords.latitude,
                    lon: position.coords.longitude,
                    count: 1
                });
                
                document.dispatchEvent(new CustomEvent('ab.analytics.event', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        eventCode: 'dadataRequestSent',
                        type: 'headerLocationDetect',
                    }
                }));
                
                request
                    .then(response => {
                        if (response.hasOwnProperty('suggestions') && response.suggestions.length > 0) {
                            const formattedItem = Dadata.getFormattedLocationItem(response.suggestions[0]);
                            this._sendLocationValue(formattedItem.id, formattedItem.name);
                        } else {
                            this._handleLocationDetectError();
                        }
                    })
                    .catch(error => this._handleLocationDetectError);
            },
            error => this._handleLocationDetectError(error)
        );
    }

    _showLocationDefaults() {
        this._searchRadiosList.innerHTML = this._getLocationListHTML(this._defaultLocations);
        this._initRadiosList();
    }

    _showLocationSearchResults(items) {
        this._searchRadiosList.innerHTML = this._getLocationListHTML(this._formatDadataSuggestions(items));
        this._initRadiosList();
    }

    _initRadiosList() {
        const radios = this._searchRadiosList.querySelectorAll('[name="location"]');
        radios.forEach(item => {
            item.addEventListener('change', this._handleChooseLocation);
        });
    }

    _formatDadataSuggestions(items) {
        const formattedItems = [];
        items.forEach(function(item) {
            if (Dadata.isValidLocationItem(item)) {
                formattedItems.push(Dadata.getFormattedLocationItem(item));
            }
        })
        return formattedItems;
    }

    _showLocationEmpty() {
        this._searchRadiosList.innerHTML = `<div class="loc-search__error">Такого города не найдено</div>`;
    }

    _sendLocationValue(value, name) {
        BX.ajax.runAction('alpina:core.api.userlocation.set', {
            data: {
                kladrId: value,
                name: name
            }
        }).then(response => {
            window.location.reload();
        }, response => {
            console.log(response);
        })
    }
}

(function () {
    class Header {
        constructor(params) {
            const headerNode = document.querySelector('.js-header');
            if (headerNode) {
                this._node = headerNode;
                this._updateState = this._updateState.bind(this);
                this._stick = this._stick.bind(this);
                this._unstick = this._unstick.bind(this);
                this._handleContactsClick = this._handleContactsClick.bind(this);
            } else {
                throw new Error('No header present. Creation cancelled.');
            }
        }

        _updateState() {
            this._updateStickyState();
            this._updateHiddenState();
            
            this._lastWindowScrollPosition = window.pageYOffset;
        }
        
        _stick() {
            if (!this.sticked) {
                this._insertHeaderHolder();
                this._cloneMenu();
                
                this._node.classList.add('header_sticked');
                this.sticked = true;
                
                this._lastStickPosition = window.pageYOffset;
                
                this._triggerStickEvent();
            }
        }
        
        _unstick() {
            const holders = document.querySelectorAll('.js-header-holder');
            if (holders.length > 0) {
                holders.forEach(holder => {
                    holder.remove();
                });
                this._removeClonedMenu();
                
                this._node.classList.remove('header_sticked');
                this.sticked = false;
                
                this._lastStickPosition = null;
                
                this._triggerStickEvent();
            }
        }

        _updateStickyState() {
            if (!this.sticked) {
                if (this._node.getBoundingClientRect().bottom <= -100) {
                    this._stick();
                }
                
            } else {
                const holders = document.querySelectorAll('.js-header-holder');
                if (holders.length > 0) {
                    let doRemove = false;
                    holders.forEach(holder => {
                        if (holder.getBoundingClientRect().bottom > 0) {
                            doRemove = true;
                            holder.remove();
                        }
                    });
                    if (doRemove) {
                        this._removeClonedMenu();
                        
                        this._node.classList.remove('header_sticked');
                        this.sticked = false;
                        
                        this._lastStickPosition = null;
                        
                        this._triggerStickEvent();
                    }
                }
            }
        }
        
        _updateHiddenState() {
            const currentWindowScrollPosition = window.pageYOffset;
            
            if (!this.sticked) {
                if (this._node.getBoundingClientRect().bottom < 0) {
                    this._node.style.visibility = 'hidden';

                } else {
                    this._node.style.visibility = 'visible';
                }
                
            } else {
                if (this._lastWindowScrollPosition < currentWindowScrollPosition) {
                    // Скролл вниз
                    // Здесь логичнее использовать transform: translateY, но это ломает дропы по какой-то причине
                    // Поэтому используется top
                    this._node.style.top = `-${this._node.getBoundingClientRect().height}px`;
                    this.hiddenState = true;
                    
                } else if (this._lastWindowScrollPosition > currentWindowScrollPosition) {
                    // Скролл вверх
                    this._node.style.top = '0';
                    this.hiddenState = false;
                }
                
                if ((this._lastStickPosition + 200) < currentWindowScrollPosition) {
                    this._node.style.visibility = 'visible';
                }
            }
        }

        _triggerStickEvent() {
            const event = new CustomEvent('header.stick.' + this.sticked, {
                bubbles: true,
                cancelable: true
            });
            this._node.dispatchEvent(event);
        }

        _insertHeaderHolder() {
            const holder = document.createElement('div');
            holder.classList.add('header-placeholder', 'js-header-holder');

            const computedStyle = window.getComputedStyle(this._node);
            holder.style.marginTop = computedStyle.marginTop;
            holder.style.marginRight = computedStyle.marginRight;
            holder.style.marginBottom = computedStyle.marginBottom;
            holder.style.marginLeft = computedStyle.marginLeft;

            this._node.parentNode.insertBefore(holder, this._node);
        }

        _cloneMenu() {
            if (!this._centerNode.querySelector('.js-header__menu-cloned')) {
                const clonedMenu = this._menuNode.cloneNode(true);
                clonedMenu.classList.add('header__bottom-catalog_cloned', 'nav-catalog_cloned', 'js-header__menu-cloned');
                this._centerNode.insertBefore(clonedMenu, this._searchNode);
            }
        }

        _removeClonedMenu() {
            const clonedMenu = this._centerNode.querySelector('.js-header__menu-cloned');
            if (clonedMenu) {
                clonedMenu.remove();
            }
        }

        _handleContactsClick(event) {
            if (this._contactsNode.classList.contains('header__contacts_expanded')) {
                this._contactsNode.classList.remove('header__contacts_expanded');
            } else if (!event.target.hasAttribute('href') && (event.target === this._contactsNode || this._contactsNode.contains(event.target))) {
                this._contactsNode.classList.add('header__contacts_expanded');
            }
        }
        
        getHeightOnScreen(withBanners = false) {
            let height = this._node.offsetHeight;
            let heightOnScreen;
            if (!this.sticked) {
                if (withBanners) {
                    const nodeAlert = document.querySelector('.js-banner-alert');
                    const nodeBanner = document.querySelector('.js-banner-header');
                    [nodeAlert, nodeBanner].forEach(node => {
                        if (node) {
                            height += node.offsetHeight;
                        }
                    });
                }
                const deltaWithScroll = height - window.scrollY;
                heightOnScreen = (deltaWithScroll > 0) ? deltaWithScroll : 0;
            } else {
                heightOnScreen = height;
            }
            return heightOnScreen;
        }
        
        getBottomPosOnScreen() {
            return this._node.getBoundingClientRect().bottom;
        }

        init() {
            this.sticked = false;
            this.hiddenState = false;
            this._topNode = this._node.querySelector('.js-header__top');
            this._centerNode = this._node.querySelector('.js-header__center');

            this._menuNode = this._node.querySelector('.js-nav-catalog');
            this._searchNode = this._node.querySelector('.js-header__search');
            this._contactsNode = this._node.querySelector('.js-header__contacts');

            const locationPin = this._node.querySelector('.js-header__loc-pin');
            if (locationPin) {
                this._locationPin = new LocationInterface({element: locationPin});
            }
            
            this._lastWindowScrollPosition = window.pageYOffset;

            // todo исключить ненужные триггеры
            if (this._contactsNode) {
                document.addEventListener('click', this._handleContactsClick);
            }
            // todo дебаунс
            window.addEventListener('scroll', this._updateState);
            
            'menu.account.open menu.catalog.open'.split(' ').forEach(evCode => {
                document.addEventListener(evCode, event => {
                    this._stick();
                });
            });
            'menu.account.close menu.catalog.close'.split(' ').forEach(evCode => {
                document.addEventListener(evCode, event => {
                    if (evCode === 'menu.catalog.close' && (window.isMobileCatalogRootOpen || window.isMobileCatalogCategoryOpen))
                        return false;
                    
                    this._unstick();
                    this._updateStickyState();
                });
            });
            
            document.addEventListener('menu.account.beforeOpen', event => {
                this._node.classList.add('header_mob-contacts-shown');
            });
            
            document.addEventListener('menu.account.beforeClose', event => {
                this._node.classList.remove('header_mob-contacts-shown');
            });
        }
    }

    class Dropdown {
        constructor(params) {
            if ('wrapper' in params && params['wrapper'] instanceof Node) {
                this._handleWindowResize = this._handleWindowResize.bind(this);
                this._wrapper = params['wrapper'];
                if ('category' in params) {
                    this._drops = [];
                    this._category = params.category;
                }
                if ('menuItem' in params && params['menuItem'] instanceof Node) {
                    this._menuItem = params['menuItem'];
                }
            } else {
                throw new Error('No wrapper provided. Creation cancelled.');
            }
        }

        _destroy() {
            window.removeEventListener('resize', this._handleWindowResize);

            const event = new CustomEvent('dropdown.destroy', {
                detail: {
                    target: this._el,
                    category: this._category
                },
                bubbles: true,
                cancelable: true
            });
            document.dispatchEvent(event);

            this._drops = null;
            this._category = null;

            this._holder = null;
            this._el.remove();
            this._el = null;
        }

        _create() {
            const el = document.createElement('div');
            const wrapperHeight = this._wrapper.offsetHeight - parseFloat(getComputedStyle(this._wrapper).marginTop) - parseFloat(getComputedStyle(this._wrapper).marginBottom);
            const wrapperOffsetTop = this._wrapper.offsetTop;
            const dropdownTopPos = wrapperHeight + wrapperOffsetTop - window.scrollY;

            el.style.setProperty('top', `${dropdownTopPos}px`);
            el.classList.add('header__dropdown', 'js-header__dropdown');
            el.innerHTML = `<div class="header__dropdown-container"><div class="header__dropdown-content"><div class="header__dropdown-holder"></div></div></div>`;
            this._el = el;

            this._wrapper.appendChild(this._el);
            this._holder = this._el.querySelector('.header__dropdown-holder');

            if (this._category.links) {
                const bottomLinksUl = document.createElement('ul');
                bottomLinksUl.classList.add('header__dropdown-bottom');
                this._category.links.forEach(function(item) {
                    const li = document.createElement('li');
                    li.classList.add('header__dropdown-bottom-li');
                    li.innerHTML = `<a href="${item.link}">${item.text}</a>`;
                    bottomLinksUl.appendChild(li);
                })
                const content = this._el.querySelector('.header__dropdown-content');
                if (content) {
                    content.insertAdjacentElement('afterbegin', bottomLinksUl);
                }
            }

            this._lockWindowScroll();

            const event = new CustomEvent('dropdown.create', {
                detail: {
                    target: this._el,
                },
                bubbles: true,
                cancelable: true
            });
            document.dispatchEvent(event);
            
            if (this._menuItem) {
                this._menuItem.addEventListener('mouseleave', event => {
                    const content = this._el.querySelector('.header__dropdown-content');
                    if (content) {
                        if (!content.matches(':hover')) {
                            this._destroy();
                            this._unlockWindowScroll();
                        } else {
                            if (this._el) {
                                this._el.querySelectorAll('.header__dropdown-holder, .header__dropdown-bottom').forEach(el => {
                                    el.addEventListener('mouseleave', event => {
                                        const dropHolder = this._el.querySelector('.header__dropdown-holder');
                                        const dropBottom = this._el.querySelector('.header__dropdown-bottom');
                                        
                                        if ((dropHolder && dropHolder.matches(':hover')) || (dropBottom && dropBottom.matches(':hover')))
                                        {} else {
                                            this._destroy();
                                            this._unlockWindowScroll();
                                        }
                                    });
                                });
                            }
                        }
                    }
                }, {once : true});
            }
        }

        _createChild(category) {
            if ('items' in category && Array.isArray(category.items) && category.items.length > 0) {
                const ul = document.createElement('ul');
                ul.classList.add('nav-drop');

                category.items.forEach((item) => {
                    const li = document.createElement('li');
                    li.classList.add('nav-drop__li');

                    const a = document.createElement('a');
                    a.classList.add('nav-drop__a');
                    a.setAttribute('data-category-id', item.id);
                    a.setAttribute('data-menu-level', this._drops.length + 1);
                    a.setAttribute('href', item.link);

                    if (item.isBold) {
                        a.classList.add('nav-drop__a_bold');
                    }
                    if (Array.isArray(item.items) && item.items.length > 0) {
                        a.classList.add('nav-drop__a_parent');
                    }

                    a.addEventListener('mouseenter', (event) => {
                        if (!event.target.classList.contains('nav-drop__a_parent')) return false;

                        const level = parseInt(event.target.getAttribute('data-menu-level'));
                        const categoryId = parseInt(event.target.getAttribute('data-category-id'));

                        const parent = event.target.closest('.nav-drop');
                        parent.querySelectorAll('.nav-drop__a').forEach(function(sibling) {
                            sibling.classList.remove('nav-drop__a_in-path');
                        });
                        event.target.classList.add('nav-drop__a_in-path');

                        // todo удалять по перебору массива this._drops

                        const drops = this._holder.querySelectorAll('.menu-drops__item');
                        drops.forEach(function(drop) {
                            if (parseInt(drop.getAttribute('data-menu-level')) > level) {
                                drop.remove();
                            }
                        })

                        if (this._drops.length > level) {
                            this._drops.splice(level - this._drops.length);
                        }

                        const currentDrop = this._drops[level - 1];
                        if ('items' in currentDrop.category && currentDrop.category.items.length > 0) {
                            const dropItems = currentDrop.category.items;
                            for (let i = 0; i < dropItems.length; i++) {
                                if (parseInt(dropItems[i].id) === categoryId) {
                                    this._createChild(dropItems[i]);
                                }
                            }
                        }
                    })
                    
                    a.innerHTML = `<span>${item.text}</span>`;
                    if (item.isNew) {
                        a.innerHTML += '&nbsp;';
                        a.classList.add('nav-drop__a_new');
                    }
                    li.appendChild(a);

                    ul.appendChild(li);
                })

                const wrap = document.createElement('div');
                wrap.classList.add('menu-drops__item');
                wrap.appendChild(ul);
                wrap.setAttribute('data-menu-level', this._drops.length + 1);
                this._holder.appendChild(wrap);
                new SimpleBar(wrap);

                this._drops.push({
                    node: wrap,
                    category: category
                });

                const event = new CustomEvent('dropdown.child.create', {
                    detail: {
                        target: this._el,
                        activeTarget: wrap,
                        activeCategory: category
                    },
                    bubbles: true,
                    cancelable: true
                });
                document.dispatchEvent(event);
            }
        }

        _showFirstCategory() {
            const wrap = this._drops[0].node;
            const aParentFirst = wrap.querySelector('a.nav-drop__a_parent');
            if (aParentFirst) {
                const mouseenterEvent = new Event('mouseenter');
                aParentFirst.dispatchEvent(mouseenterEvent);
            }
        }

        _handleWindowResize(event) {
            const isDesktop = window.innerWidth >= globObj.breakpoints.lg;
            if (!isDesktop) {
                this._destroy();
                this._unlockWindowScroll();
            }
        }

        _lockWindowScroll() {
            // todo избавиться в будущем от такого использования
            bodyScrollLock.disableBodyScroll(this._wrapper, {reserveScrollBarGap: true});
        }

        _unlockWindowScroll() {
            // todo избавиться в будущем от такого использования
            bodyScrollLock.clearAllBodyScrollLocks();
        }
        
        destroy() {
            this._destroy();
        }

        init() {
            this._create();
            this._createChild(this._category);
            this._showFirstCategory();

            document.addEventListener('click', this._handleDocumentClick);
            // todo дебаунс
            window.addEventListener('resize', this._handleWindowResize);
        }
    }

    $(function () {
        const scriptsIdsToRemove = ['headerMenuScript', 'topCityScript', 'userCityScript', 'headerCountersScript'];
        scriptsIdsToRemove.forEach(id => {
            const scriptNode = document.getElementById(id);
            if (scriptNode) {
                scriptNode.remove();
            }
        });

        const header = document.querySelector('.js-header');
        if (header) {
            window.Header = new Header();
            window.Header.init();
        }

        // установка флага, нужен ли лейбл у аккаунта
        window.isAccountLabeled = false;
        if (globHeaderMenu && globHeaderMenu.length > 0) {
            globHeaderMenu.forEach(function(item) {
                if (item.text === 'Мои заказы' && 'hasUnpaidOrder' in window
                    || item.text === 'Мои данные' && 'needMergeAccounts' in window && window.needMergeAccounts) {
                    window.isAccountLabeled = true;
                }
            })
        }

        function showMobileMenu () {
            const top = header.querySelector('.js-header__top')
            const bottom = header.querySelector('.js-header__bottom')

            const clonedTop = top.cloneNode(true);
            const clonedBottom = bottom.cloneNode(true);
    
            // подписку и пин местоположения готовим к переносу
            const sub = clonedTop.querySelector('.js-header__sub');
            const subClone = sub.cloneNode(true);
            sub.remove();
            // const pin = clonedTop.querySelector('.js-header__loc');
            // const pinClone = pin.cloneNode(true);
            // pin.remove();
            
            // const gadgetMenuAcc = document.createElement('div');
            // gadgetMenuAcc.classList.add('header__personal-mob');
            // if ('userLogged' in window.user && window.user.userLogged) {
            //     gadgetMenuAcc.classList.add('header__personal-mob_logged');
            //     const headerAcc = header.querySelector('.js-header-acc-desktop__item-acc');
            //     const node = headerAcc.cloneNode(true);
            //     node.classList.remove('js-header-acc-desktop__item-acc');
            //     node.href = 'javascript:;';
            //     gadgetMenuAcc.classList.add('js-header-acc-mob');
            //     gadgetMenuAcc.appendChild(node);
            // } else {
            //     // не залогинен
            //     const headerLogin = header.querySelector('.js-header-acc-login');
            //     const node = headerLogin.cloneNode(true);
            //     gadgetMenuAcc.appendChild(node);
            // }
            //
            const gadgetMenuContent = document.createElement('div');
            gadgetMenuContent.classList.add('mobile-nav');
            //
            if (subClone) {
                gadgetMenuContent.appendChild(subClone);
            }
            // if (pinClone) {
            //     gadgetMenuContent.appendChild(pinClone);
            // }
            // if (gadgetMenuAcc) {
            //     gadgetMenuContent.appendChild(gadgetMenuAcc);
            // }
            if (clonedBottom) {
                gadgetMenuContent.appendChild(clonedBottom);
            }
            // if (clonedTop) {
            //     gadgetMenuContent.appendChild(clonedTop);
            // }

            const gadgetMenuWrap = document.createElement('div');
            gadgetMenuWrap.classList.add('nav-fancybox');
            gadgetMenuWrap.appendChild(gadgetMenuContent);
    
            // Инициализация ссылок на модалки внутри мобильного меню, если такие есть
            const fancyboxLinks = gadgetMenuContent.querySelectorAll('[data-fancybox]');
            if (fancyboxLinks.length > 0) {
                fancyboxLinks.forEach(element => {
                    $(element).iModalInit();
                })
            }

            $.fancybox.open({
                src: gadgetMenuWrap,
                type: 'html',
                
                animationDuration: 300,
                animationEffect: 'mobile-menu-catalog-root',

                closeExisting: true,
                smallBtn: false,
                touch: false,
                autoFocus: false,

                baseTpl:
                    '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                    '<div class="fancybox-bg"></div>' +
                    '<div class="fancybox-stage"></div>' +
                    '</div>',
                baseClass: "fancybox-menu-mobile",

                clickOutside: "close",

                beforeShow: function(instance, slide) {
                    window.isMobileCatalogRootOpen = true;
                    
                    document.dispatchEvent(new CustomEvent('menu.catalog.beforeOpen', {
                        bubbles: true,
                        cancelable: true
                    }));
                    
                    const modalMenuFancybox = slide.$slide[0].closest('.fancybox-container');
                    if (modalMenuFancybox) {
                        const offsetTop = window.Header._node.offsetHeight;
                        const offsetBottom = window.bottomBar.methods.getPositionTop();
                        modalMenuFancybox.style.top = offsetTop + 'px';
                        modalMenuFancybox.style.bottom = offsetBottom + 'px';
                        modalMenuFancybox.style.height = `calc(100% - ${offsetTop}px - ${offsetBottom}px)`;
                    }
                },
                afterShow: function (instance, slide) {
                    const inner = slide.src.querySelector('.mobile-nav');
                    if (inner) {
                        new SimpleBar(inner);
                    }
                    
                    document.dispatchEvent(new CustomEvent('menu.catalog.open', {
                        bubbles: true,
                        cancelable: true
                    }));
                    
                    setTimeout(() => {
                        bodyScrollLock.disableBodyScroll(slide.src.querySelector('.simplebar-content-wrapper'));
                    }, 100);
                },

                beforeClose: function (instance, slide) {
                    document.dispatchEvent(new CustomEvent('menu.catalog.beforeClose', {
                        bubbles: true,
                        cancelable: true
                    }));
                    
                    window.isMobileCatalogRootOpen = false;
                },
                
                afterClose: function (instance, slide) {
                    bodyScrollLock.enableBodyScroll(slide.src.querySelector('.simplebar-content-wrapper'));
                    
                    document.dispatchEvent(new CustomEvent('menu.catalog.close', {
                        bubbles: true,
                        cancelable: true
                    }));
                },

                lang: "ru",
            })
        }


        // меню по каталогу
        const catalogMenu = header.querySelector('.js-nav-catalog');
        if (catalogMenu) {
            if (window.globalHeaderData && window.globalHeaderData.menu && window.globalHeaderData.menu.catalog && window.globalHeaderData.menu.catalog.items) {
                const catalogFormatted = formatCatalogData(window.globalHeaderData.menu.catalog.items);

                let currentDropdown;
                
                function formatCatalogData (items = []) {
                    function formatLayer (layer, level = 0, parentId = 0) {
                        let result = {};
                        for (let key in layer) {
                            if (Array.isArray(layer[key].items) && layer[key].items.length > 0) {
                                // todo возможно, вырезать дочерние элементы
                                result = Object.assign({}, result, formatLayer(layer[key].items, level + 1, layer[key].id));
                                result[layer[key].id] = layer[key];
                                result[layer[key].id].parentId = parentId;
                                result[layer[key].id].level = level;
                            }
                        }
                        return result;
                    }
                    return formatLayer(items, 0, 0);
                }
                function isMenuMobile () {
                    return window.innerWidth < globObj.breakpoints.lg;
                }
    
                // category.type = 'account' - вывод меню по аккаунту
                function getMobileMenuCategoryNode (category) {
                    if (Array.isArray(category.items) && category.items.length > 0) {
                        const wrapNode = document.createElement('div');
                        wrapNode.classList.add('mobile-nav-category', 'js-nav-catalog-mobile');
                        const menuNode = document.createElement('ul');
                        menuNode.classList.add('nav-drop');
                        if (category.type) {
                            menuNode.classList.add('nav-drop_' + category.type);
                        }
                        const backNode = getMobileMenuCategoryLiNode('back', category);
                        menuNode.appendChild(backNode);
                        if ('links' in category && Array.isArray(category.links) && category.links.length > 0) {
                            const linksNode = getMobileMenuCategoryLinks(category.links);
                            menuNode.appendChild(linksNode);
                        }
                        category.items.forEach(function(element, index) {
                            if (index > 0) {
                                const liNode = getMobileMenuCategoryLiNode((element.isLogout) ? 'logout' : 'default', element);
                                menuNode.appendChild(liNode);
                            }
                        })
                        wrapNode.appendChild(menuNode);
                        return wrapNode;
                    } else {
                        return '';
                    }
                }

                function getMobileMenuCategoryLiNode (type = 'default', item) {
                    const li = document.createElement('li');
                    li.classList.add('nav-drop__li');
                    const a = document.createElement('a');
                    a.classList.add('nav-drop__a');
                    if (item.isBold) {
                        a.classList.add('nav-drop__a_bold');
                    }
                    if (type === 'back') {
                        li.classList.add('nav-drop__li_back');
                        a.setAttribute('href', 'javascript:;');
                        a.setAttribute('data-category-id', item.parentId);
                        a.textContent = item.text;
                        a.classList.add('nav-drop__a_back', 'js-nav-catalog-mobile__item');
                        
                        li.insertAdjacentHTML(
                            'beforeend',
                            `<a href="${item.items[0].link}" class="nav-drop__li-link-to-all"><span>Все</span></a>`,
                        );
                        li.classList.add('nav-drop__li_has-link-to-all-on-mobile');
                    
                    } else if (type === 'default' || type === 'logout') {
                        if (type === 'logout') {
                            li.classList.add('nav-drop__li_logout');
                        }
                        if (Array.isArray(item.items) && item.items.length > 0) {
                            a.setAttribute('href', 'javascript:;');
                            a.classList.add('nav-drop__a_parent', 'js-nav-catalog-mobile__item');
                            a.setAttribute('data-category-id', item.id);
                        } else {
                            a.setAttribute('href', item.link);
                        }
                        
                        a.innerHTML = `<span>${item.text}</span>`;
                        if (item.isNew) {
                            a.innerHTML += '&nbsp;';
                            a.classList.add('nav-drop__a_new');
                        }
                    }
                    li.appendChild(a);
                    return li;
                }

                function getMobileMenuCategoryLinks (links) {
                    const ul = document.createElement('ul');
                    ul.classList.add('nav-links', 'nav-links_category');
                    links.forEach(function(item) {
                        const li = document.createElement('li');
                        li.classList.add('nav-links__li');
                        li.innerHTML = `<a href="${item.link}" class="nav-links__a">${item.text}</a>`;
                        ul.appendChild(li);
                    })

                    return ul;
                }

                // category.type = 'account' - вывод меню по аккаунту
                function showMobileMenuCategory (category) {
                    const menuWrap = document.createElement('div');
                    menuWrap.classList.add('nav-fancybox');

                    const menuNode = getMobileMenuCategoryNode(category);
                    menuWrap.appendChild(menuNode);
                    // todo сделать стандартным методом с кастомными настройками
                    $.fancybox.open({
                        src: menuWrap,
                        type: 'html',
                        
                        animationDuration: 300,
                        animationEffect: 'mobile-menu-catalog-category',

                        closeExisting: true,
                        smallBtn: false,
                        touch: false,
                        autoFocus: false,

                        baseTpl:
                            '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                            '<div class="fancybox-bg"></div>' +
                            '<div class="fancybox-stage"></div>' +
                            '</div>',
                        baseClass: "fancybox-menu-mobile",

                        clickOutside: "close",
                        
                        beforeShow: function(instance, slide) {
                            window.isMobileCatalogCategoryOpen = true;
                            
                            document.dispatchEvent(new CustomEvent('menu.catalog.beforeOpen', {
                                bubbles: true,
                                cancelable: true
                            }));
                            
                            const modalMenuFancybox = slide.$slide[0].closest('.fancybox-container');
                            if (modalMenuFancybox) {
                                const offsetTop = window.Header._node.offsetHeight;
                                const offsetBottom = window.bottomBar.methods.getPositionTop();
                                modalMenuFancybox.style.top = offsetTop + 'px';
                                modalMenuFancybox.style.bottom = offsetBottom + 'px';
                                modalMenuFancybox.style.height = `calc(100% - ${offsetTop}px - ${offsetBottom}px)`;
                            }
                        },

                        afterShow: function (instance, slide) {
                            const inner = slide.src.querySelector('.mobile-nav-category');
                            if (inner) {
                                new SimpleBar(inner);
                            }
                            
                            document.dispatchEvent(new CustomEvent('menu.catalog.open', {
                                bubbles: true,
                                cancelable: true
                            }));
                            
                            setTimeout(() => {
                                bodyScrollLock.disableBodyScroll(slide.src.querySelector('.simplebar-content-wrapper'));
                            }, 100);
                        },

                        beforeClose: function (instance, slide) {
                            document.dispatchEvent(new CustomEvent('menu.catalog.beforeClose', {
                                bubbles: true,
                                cancelable: true
                            }));
                            
                            window.isMobileCatalogCategoryOpen = false;
                        },
                        
                        afterClose: function (instance, slide) {
                            bodyScrollLock.enableBodyScroll(slide.src.querySelector('.simplebar-content-wrapper'));
                            
                            document.dispatchEvent(new CustomEvent('menu.catalog.close', {
                                bubbles: true,
                                cancelable: true
                            }));
                        },

                        lang: "ru",
                    })
                }

                function showDesktopMenuCategory (category, event) {
                    const dropdown = new Dropdown({
                        wrapper: header,
                        category: category,
                        menuItem: event.target
                    });
                    currentDropdown = dropdown;
                    dropdown.init();
                }

                function showMenuCategory (category, event) {
                    if (isMenuMobile()) {
                        showMobileMenuCategory(category, event);
                    } else {
                        showDesktopMenuCategory(category, event);
                    }
                }
                
                function handleOpenCategory(event) {
                    const classesToCheck = ['js-nav-catalog__item-root', 'js-nav-catalog-mobile__item'];
                    let foundClass = false;
                    let mainElement;
                    for (let i = 0; i < classesToCheck.length; i++) {
                        if (event.target.classList.contains(classesToCheck[i])) {
                            foundClass = classesToCheck[i];
                            mainElement = event.target;
                        } else if (event.target.closest('.'+classesToCheck[i])) {
                            foundClass = classesToCheck[i];
                            mainElement = event.target.closest('.'+classesToCheck[i]);
                        }
                    }
                    if (foundClass) {
                        event.preventDefault();
                        
                        if (currentDropdown) {
                            currentDropdown.destroy();
                            currentDropdown = undefined;
                        }
                        
                        const categoryId = mainElement.getAttribute('data-category-id');
                        if (!categoryId || categoryId === '0') {
                            if (isMenuMobile()) {
                                showMobileMenu();
                            }
                        } else if (categoryId > 0 && catalogFormatted[categoryId]) {
                            showMenuCategory(catalogFormatted[categoryId], event);
                        }
                    }
                }

                window.addEventListener('resize', function(event) {
                    const instance = $.fancybox.getInstance();
                    if (instance && instance.current.src.id === 'modalMenuAccount' && !isMenuMobile()) {
                        $.fancybox.close();
                    }
                })

                // пункты меню по каталогу
                document.addEventListener('click', function(event) {
                    if (isMenuMobile()) {
                        handleOpenCategory(event);
                    }
                });
                document.addEventListener('mouseover', function(event) {
                    if (!isMenuMobile()) {
                        handleOpenCategory(event);
                    }
                })
                
                // меню по аккаунту
                document.addEventListener('click', function(event) {
                    if (globHeaderMenu && globHeaderMenu.length > 0 && isMenuMobile()) {
                        const classesToCheck = ['js-header-acc-mob'];
                        let foundClass = false;
                        for (let i = 0; i < classesToCheck.length; i++) {
                            if (event.target.classList.contains(classesToCheck[i]) || event.target.closest('.'+classesToCheck[i])) {
                                foundClass = classesToCheck[i];
                            }
                        }
                        if (foundClass) {
                            showMobileMenuCategory({
                                type: 'account',
                                items: globHeaderMenu
                            });
                        }
                    }
                })

                // создание дочернего уровня в дропе
                document.addEventListener('dropdown.child.create', function(event) {
                    if (event.detail.activeCategory.level === 0) {
                        const catalogMenuItems = document.querySelectorAll('.js-nav-catalog__item-root');
                        if (catalogMenuItems.length > 0) {
                            catalogMenuItems.forEach(function(item) {
                                const itemId = parseInt(item.getAttribute('data-category-id'));
                                if (itemId === event.detail.activeCategory.id) {
                                    item.classList.add('nav-catalog__a_in-route');
                                } else {
                                    item.classList.remove('nav-catalog__a_in-route');
                                }
                            })
                        }
                    }
                })

                document.addEventListener('dropdown.destroy', function(event) {
                    const catalogMenuItem = document.querySelector(`.js-nav-catalog__item-root[data-category-id='${event.detail.category.id}']`);
                    if (catalogMenuItem) {
                        catalogMenuItem.classList.remove('nav-catalog__a_in-route');
                    }
                    
                    if (currentDropdown) {
                        currentDropdown = undefined;
                    }
                })
                
                if (typeof window.Header.methods !== 'object' || window.Header.methods === null) {
                    window.Header.methods = {};
                }
                
                window.Header.methods.openCatalogMobile = function() {
                    if ('globalHeaderData' in window && 'activeCategories' in window.globalHeaderData && window.globalHeaderData.activeCategories.length > 0) {
                        let showCategory;
                        for (let i = window.globalHeaderData.activeCategories.length - 1; i >= 0 && !showCategory; i--) {
                            const formattedCategory = catalogFormatted[window.globalHeaderData.activeCategories.slice(i - window.globalHeaderData.activeCategories.length)[0]];
                            if (formattedCategory) {
                                showCategory = formattedCategory
                            }
                        }
                        if (showCategory) {
                            showMobileMenuCategory(showCategory);
                        } else {
                            showMobileMenu();
                        }
                    } else {
                        showMobileMenu();
                    }
                }
                
                window.Header.methods.closeCatalogMobile = function() {
                    $.fancybox.close();
                };
            }
        }
        
        // События клика по определенным пунктам меню в шапке
        document.addEventListener('click', function(event) {
            if (event.target.classList.contains('nav-catalog__a_link')) {
                document.dispatchEvent(new CustomEvent('ab.analytics.event', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        eventCode: 'lectoriiLinkClick',
                    }
                }));
                
            } else if (event.target.classList.contains('js-header__sub-badge') || event.target.closest('.js-header__sub-badge')) {
                document.dispatchEvent(new CustomEvent('ab.analytics.event', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        eventCode: 'subscribeLinkClick',
                    }
                }));
            }
        });
    });


    $(function () {
        /**
         * Поиск в шапке
         */

        // чистим от служебного параметра урл при загрузке страницы
        window.history.replaceState('', '', globalFunctions.deleteGetParam(window.location.href, "from_quick_search"));

        const classFixed = "_header-fixed";
        const classTight = "_header-tight";

        const classMain = "js-header-search-suggests";
        const classInner = "js-header-search-suggests__inner";
        const modifHidden = "_hidden";


        // собрать окно с саджестами, добавить его на страницу и вернуть

        function renderHeaderSuggests(arBlocks = [], bottomLink = false) {
            const $suggestsWindow = $('.js-header-search-suggests');
            
            let wrapHtmlInside = ``;
            if (arBlocks.length > 0) {
                $.each(arBlocks, function (i, block) {
                    let isBooks = (block.isBooks) ? block.isBooks : false;
                    wrapHtmlInside += renderHeaderSuggestsBlock(block.items, block.title, isBooks);
                });
            }

            let bottomHtml = ``;
            if (bottomLink) {
                bottomHtml =
                    `<div class="header-suggests__bottom">` +
                    `<a class="header-suggests__bottom-link" href="${bottomLink}">Посмотреть все</a>` +
                    `</div>`;
            }
    
            if ($suggestsWindow.length > 0) {
                $suggestsWindow.find('.js-header-search-suggests__inner').html(wrapHtmlInside + bottomHtml);
            } else {
                const wrapHtmlOpen =
                    `<div class="header-suggests js-header-search-suggests">` +
                    `<div class="header-suggests__inner js-header-search-suggests__inner">`;
                const wrapHtmlClose =
                    `</div>` +
                    `</div>`;
                $("body").append(wrapHtmlOpen + wrapHtmlInside + bottomHtml + wrapHtmlClose);
            }
            
            return $("body").find(".js-header-search-suggests");
        }

        // скомпоновать и вернуть один блок окна саджестов поиска

        function renderHeaderSuggestsBlock(arItems, title = false, isBooks = false) {
            const blockHtmlOpen =
                `<div class="header-suggests__block">` +
                (( title ) ? `<span class="header-suggests__block-title">${title}</span>` : ``);

            const blockHtmlClose =
                `</div>`;

            let blockHtmlInside = ``;

            if (isBooks) {
                $.each( arItems, function (i, item) {
                    blockHtmlInside +=
                        `<a href="${item.link}" class="header-suggest-book js-search-res__book" data-offer-id="${item.offerId}">` +
                        `<picture class="header-suggest-book__picture">` +
                        `<source srcset="${item.imgs.x3} 3x, ${item.imgs.x2} 2x, ${item.imgs.x1}">` +
                        `<img src="${item.imgs.x1}">` +
                        `</picture>` +

                        `<div class="header-suggest-book__info">` +
                        `<div class="header-suggest-book__info-title">`+
                        ( (item.subtitle) ? `${item.title}.<br>${item.subtitle}` : `${item.title}` ) +
                        `</div>` +
                        `<div class="header-suggest-book__info-author"><span>${item.author}</span></div>` +
                        `</div>` +

                        `<div class="header-suggest-book__price">` +
                        ( (item.priceOld > 0) ? `<span class="header-suggest-book__price-item _old">${((item.multipleOffers) ? 'от&nbsp;' : '') + item.priceOld} руб.</span>` : `` ) +
                        `<span class="header-suggest-book__price-item">${(item.price > 0) ? ((item.multipleOffers) ? 'от&nbsp;' : '') + item.price+" руб." : ""}</span>` +
                        `</div>` +
                        `</a>`;
                });

            } else {
                $.each( arItems, function (i, item) {
                    blockHtmlInside +=
                        `<a href="${item.link}" class="header-suggest-line` + ( (item.categoryId !== undefined) ? ` js-search-res__category" data-category-id="${item.categoryId}"` : `"` ) + `>` +
                        `<div class="header-suggest-line__name">${item.title}</div>` +
                        ( (item.counter > 0) ? `<div class="header-suggest-line__counter">${item.counter}</div>` : `` ) +
                        `</a>`;
                });
            }

            return blockHtmlOpen + blockHtmlInside + blockHtmlClose;
        }

        $(".js-header__search").each(function () {
            const $wrap = $(this);
            const $input = $wrap.find("input");
            const $clear = $wrap.find(".js-header__search-clear");

            const $siteHeader = $wrap.closest('.js-site-header');

            let lastQuery; // здесь будем хранить последний запрос, чтобы проверить перед показом окна саджестов, и не показывать уже потерявшие актуальность

            // --- События


            // фокус в инпут
            $wrap.on("click", function (e) {
                e.preventDefault();

                if (!e.target.closest(".js-header-search__clear")) {
                    $wrap.addClass("header__search_focused");
                    $input.focus().trigger("focus");
                    // todo поменять класс или убрать действие
                    $siteHeader.addClass("_is-searching");
                }
            });

            // утрата фокуса в инпуте
            $input.on("blur", function () {
                const val = $input.val();
                if (val === "") {
                    removeWindow();
                    $wrap.removeClass("header__search_focused");
                    // todo поменять класс или убрать действие
                    $siteHeader.removeClass("_is-searching");
                }
            });


            // ввод в инпут
            $input.on("input", function () {
                const val = $input.val();

                if (val === "") {
                    removeWindow();
                    $wrap.removeClass("header__search_filled");
                    return false; // если пустое значение, ничего не делаем
                } else {
                    $wrap.addClass("header__search_filled");
                }

                lastQuery = val;

                globalFunctions.delay(function () {
                    if (lastQuery === val) {
                        showHeaderSuggests(val, {url: $wrap.data("kealabs-api-url"), token: $wrap.data("kealabs-api-token")}); // показываем новое окно
                    }
                }, 500)();
            });

            // нажатие на Enter (и аналоги на гаджетах - все на коде символа 13)
            // при непустом значении в поле - переходим на страницу поиска с запросом из поля
            $input.on("keypress", function (e) {
                if (e.which === 13) {
                    const val = $input.val();

                    // собираем объект для аналитики
                    $ (document).trigger ("uiEvent", [
                        {
                            event: 'UI',
                            code: "searchQuery",
                            data: {
                                query: globalFunctions.escapeStr (val)
                            }
                        }
                    ]);

                    const url = getSearchUrl();
                    if (url) {
                        window.location.href = url;
                    }
                }
            });


            // клик на крестик в поиске

            $clear.on("click", function (e) {
                e.preventDefault();

                removeWindow();
                $wrap.removeClass("header__search_focused").removeClass("header__search_filled");
                // todo поменять класс или убрать действие
                $siteHeader.removeClass("_is-searching");

                $input.val("");
                $input.blur();
            });


            // скролл и ресайз
            $(window).on("resize scroll", function () {
                resetPos(); // пересчитываем позицию на скролле и ресайзе
            });

            //Outside click
            $(document).on("click", function (e) {
                if (!e.target.closest(classMain) && !e.target.closest('.js-header__search')) {
                    const $suggestsWrap = $("body").find("." + classMain);
                    if ($suggestsWrap.length > 0 && !$suggestsWrap.hasClass(modifHidden)) {
                        $suggestsWrap.addClass(modifHidden);

                        $input.one("focus", function () {
                            $suggestsWrap.removeClass(modifHidden);
                        });
                    }
                }
            });

            function getSearchUrl () {
                const searchUrl = $wrap.data ("search-url");
                const searchGetParamName = $wrap.data ("search-get-param-name");
                const val = $input.val ();
                let urlToRedirect = false;

                if (searchUrl && searchGetParamName && val !== "") {
                    urlToRedirect = globalApp.updateURLParameter (searchUrl + "?", searchGetParamName, val);
                    urlToRedirect = globalApp.updateURLParameter (urlToRedirect, "from_quick_search", true);
                }

                return urlToRedirect || false;
            }

            function showHeaderSuggests (val, connectData) {
                if (val === "" || !connectData.url || !connectData.token) {
                    removeWindow ();
                    return false;
                }

                const ajaxData = {
                    q: val,
                    // 'filter[0]': 'type:'+searchType,
                    // 'filter[1]': 'type:certificate',
                    token: connectData.token
                };
                if(typeof searchType !== 'undefined') {
                    if (Array.isArray(searchType)){
                        searchType.forEach((a,b)=>{ajaxData['filter['+b+']'] = 'content_type:'+a;});
                        ajaxData['filter['+searchType.length+']'] = 'content_type:certificate';
                    } else {
                        ajaxData['filter[0]'] = 'content_type:' + searchType;
                        ajaxData['filter[1]'] = 'content_type:certificate';
                    }
                }
                if (window.kealabsRequestId) {
                    ajaxData.requestId = window.kealabsRequestId;
                }
                const params = {
                    method: 'GET',
                    data: ajaxData
                };
                const promise = $.ajax (connectData.url, params);
                promise
                    .done (function (response) {
                        if (response === undefined) {
                            removeWindow ();
                            return false;
                        }
                        if (!window.kealabsRequestId && response.meta && response.meta.requestId !== undefined) {
                            window.kealabsRequestId = String (response.meta.requestId);
                        }

                        const data = [];
                        const books = {
                            title: "Книги",
                            isBooks: true,
                            items: []
                        };
                        const lectures = {
                            title: "Лекции",
                            isBooks: true,
                            items: []
                        };
                        const categories = {
                            title: "Категории",
                            items: []
                        };
                        const authors = {
                            title: "Авторы",
                            items: []
                        };
                        const certificates = {
                            title: "Сертификаты",
                            isBooks: true,
                            items: []
                        };

                        if (response.results !== undefined && response.results.products && response.results.products.length > 0) {
                            $.each (response.results.products, function (i, prod) {
                                if (i === 3) return false;
                                let bookData = {
                                    bookId: prod.bookId,
                                    offerId: prod.id,
                                    title: prod.name || "",
                                    link: prod.url || "#",
                                    author: (prod.author && prod.author.length > 0) ? prod.author.join (", ") : "",
                                    price: prod.price || ""
                                };
                                if (prod.offersJson) {
                                    const offers = JSON.parse (prod.offersJson);
                                    bookData.multipleOffers = !!(offers.length > 1)
                                    for (const [key, value] of Object.entries(offers)) {
                                        if (value.id == prod.id && value.pictures) {
                                            bookData.imgs = value.pictures;
                                            bookData.multipleOffers = false;

                                            for (const [paramKey, paramValue] of Object.entries(value.param)) {
                                                if (paramValue.name === 'type') {
                                                    bookData.type = paramValue.value
                                                    break;
                                                }
                                            }

                                            if (bookData.type !== 'certificate' && bookData.type !== 'external') {
                                                bookData.title += ' ['+value.binding+']';
                                            }
                                            if (bookData.type == 'external') {
                                                bookData.link = value.url;
                                            }
                                        }
                                    }
                                }
                                if (!bookData.imgs) {
                                    bookData.imgs = {x3: prod.thumbnail, x2: prod.thumbnail, x1: prod.thumbnail}
                                }

                                if (bookData.type === 'certificate') {
                                    bookData.multipleOffers = true;
                                    bookData.price = 500; // Минимальная цена сертификата
                                    if (certificates.items.length === 0) {
                                        certificates.items.push(bookData);
                                    }
                                } else if(['course', 'event', 'external', 'multiple', 'webinar'].includes(bookData.type)) {
                                    lectures.items.push(bookData);
                                } else {
                                    books.items.push(bookData);
                                }
                            });
                        }

                        if (response.facets !== undefined && response.facets.length > 0) {
                            $.each (response.facets, function (i, facet) {
                                let checkedAuthors = false;
                                let checkedCategories = false;

                                if (
                                    facet.key === "avtor"
                                    // || facet.key === "category"
                                ) {
                                    if (facet.values.length > 0) {
                                        $.each (facet.values, function (j, val) {
                                            const itemObj = {
                                                title: val.value,
                                                link: globalApp.updateURLParameter (getSearchUrl (), "filter[" + facet.key + "][]", val.value)
                                            };

                                            if (facet.key === "category") {
                                                itemObj.counter = val.count;
                                                // из килабса приходит в виде "ID|Название", поэтому разделяем значение
                                                const arTitle = val.value.split ("|");
                                                if (arTitle.length > 2) {
                                                    itemObj.categoryId = arTitle[0];
                                                    itemObj.title = arTitle.slice (1).join ("|");
                                                } else if (arTitle.length === 2) {
                                                    itemObj.categoryId = arTitle[0];
                                                    itemObj.title = arTitle[1];
                                                } else {
                                                    // если по какой-то причине разделителя нет, то айдишник и название
                                                    // получить невозможно - тогда не выводим этот элемент
                                                    return;
                                                }
                                                categories.items.push (itemObj);
                                                checkedCategories = true;
                                            } else if (facet.key === "avtor") {
                                                authors.items.push (itemObj);
                                                checkedAuthors = true;
                                            }
                                        });
                                    }
                                }

                                if (checkedAuthors && checkedCategories) return false;
                            });
                        }

                        // порядок вывода блоков "Книги - Лекции - Категории - Авторы"
                        if (books.items.length > 0) {
                            data.push (books);
                        }
                        if (lectures.items.length > 0) {
                            data.push (lectures);
                        }
                        if (certificates.items.length > 0) {
                            data.push(certificates);
                        }
                        if (categories.items.length > 0) {
                            data.push (categories);
                        }
                        if (authors.items.length > 0) {
                            data.push (authors);
                        }

                        if (data.length > 0) {
                            const $suggestsWrap = renderHeaderSuggests (data, getSearchUrl () || "#");
                            resetPos ();
                        }

                    })
                    .fail (function (jqXHR, textStatus, errorThrown) {});
            }

            function removeWindow () {
                $("body").find("." + classMain).remove();
            }

            function resetPos () {
                const $main = $("body").find("." + classMain);
                if ($main.length === 0) return false;

                if (window.Header.sticked) {
                    $main.removeClass("_not-fixed");
                } else {
                    $main.addClass("_not-fixed");
                }

                const pos = getPos();
                $main.css({
                    "top": pos.top,
                    "left": pos.left,
                    "width": pos.width,
                    "max-height": pos.height
                });

                const $inner = $main.find("." + classInner);
                if ($inner.length > 0) {
                    new SimpleBar($inner[0]);
                }

            }

            function getPos () {
                const posTop = $wrap[0].getBoundingClientRect().top + $wrap.outerHeight() - 1;
                const posLeft = $wrap.offset().left;
                const width = $wrap.outerWidth();
                const height = $(window).outerHeight() - posTop - 50;

                return {
                    top: posTop,
                    left: posLeft,
                    width: width,
                    height: height
                };
            }
        });

        $ (document).on ("click", ".js-search-res__book", function (e) {
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: 'suggestClickBook',
                    data: {
                        offerId: globalFunctions.escapeStr ($ (this).attr ('data-offer-id')),
                        kealabsRequestId: sessionStorage.getItem('kealabsRequestId')
                    }
                }
            ]);
        });

        $ (document).on ("click", ".js-search-res__category", function (e) {
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: 'suggestClickCategory',
                    data: {
                        categoryId: globalFunctions.escapeStr ($ (this).attr ('data-category-id')),
                        kealabsRequestId: sessionStorage.getItem('kealabsRequestId')
                    }
                }
            ]);
        });
    });

    $(function () {

        /**
         * Меню профиля в шапке
         */

        const dropSelectorClass = "js-header-acc-drop";

        const $headerAccDesktop = $(".js-header-acc-desktop");

        if ($headerAccDesktop.length > 0) {

            if (typeof globHeaderMenu !== 'undefined') { // если объект с пунктами передан
                const $accDrop = renderAccDrop(globHeaderMenu);

                if ($accDrop !== false && $accDrop.length > 0) {
                    const $header = $(".js-header");
                    let hoverTimer;

                    const $accountItem = $headerAccDesktop.find('.js-header-acc-desktop__item-acc');
                    if ('isAccountLabeled' in window && window.isAccountLabeled === true) {
                        $accountItem.find('.header__personal-item-label').each(function(index, item) {
                            item.classList.add('header__personal-item-label_visible');
                            item.innerHTML = '!';
                        })
                    }

                    // ховер или нажатие на тач-дисплее
                    if ($accountItem.length > 0) {
                        const isTouch = globalFunctions.isTouchDevice();
                        const eventForTrigger = (isTouch) ? 'touchend' : 'mouseenter';
                        $accountItem.on(eventForTrigger, function (event) {
                            if (eventForTrigger === 'touchend') {
                                event.preventDefault();
                            }

                            if ($header.length > 0) {
                                if (window.Header.sticked) {
                                    $accDrop.addClass("_fixed");
                                } else {
                                    $accDrop.removeClass("_fixed");
                                }
                            }

                            calcAccDropPos($headerAccDesktop, $accDrop);

                            // --- присваиваем класс активности

                            $accDrop.addClass("_active");

                            if (!isTouch) {
                                clearTimeout(hoverTimer);
                                hoverTimer = startDropTimer($accDrop);
                            }
                        });
                    }


                    // расховер дропа

                    $accDrop.on("mouseleave", function () {
                        hoverTimer = startDropTimer($accDrop);
                    });

                    $accDrop.on("mouseenter", function () {
                        clearTimeout(hoverTimer);
                    });


                    // клик вне дропа и меню

                    $(document).on("click", function (e) {
                        if (!e.target.closest('.' + dropSelectorClass)) {
                            $accDrop.removeClass("_active");
                        }
                    });


                    // ресайзы и скроллы окна

                    $(window).on("resize", function () {
                        calcAccDropPos($headerAccDesktop, $accDrop);
                    });

                    $(document).on("scroll", function (){
                        calcAccDropPos($headerAccDesktop, $accDrop);
                    });


                    // изменения фиксации шапки

                    document.addEventListener('header.stick.true', function() {
                        $accDrop.removeClass("_fixed");
                        calcAccDropPos($headerAccDesktop, $accDrop);
                    })
                    document.addEventListener('header.stick.false', function() {
                        $accDrop.removeClass("_fixed");
                        calcAccDropPos($headerAccDesktop, $accDrop);
                    })
                }
            }
        }

        $ (document).on ('click', '.js-header-logout', function () {
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: 'logout'
                }
            ]);
        });

        function renderAccDrop (items) {
            if (items.length === 0) {
                return false;
            }

            const wrap = document.createElement('div');
            wrap.classList.add('header-acc-drop', dropSelectorClass);

            const ul = document.createElement('ul');
            ul.classList.add('header-acc-drop-ul');

            $.each( items, function (i, item) {
                // li
                let liClasses = ['header-acc-drop-ul__li'];
                const li = document.createElement('li');
                liClasses.forEach(function(className) {
                    li.classList.add(className);
                })

                // a
                const a = document.createElement('a');
                a.classList.add('header-acc-drop-ul__li-a');
                if (item.isLogout) {
                    a.classList.add('js-header-logout');
                }
                a.href = item.link;
                let aContent = `<span class="header-acc-drop-ul__li-a-text">${item.text}</span>`;

                if (item.text === 'Мои заказы' && 'hasUnpaidOrder' in window
                    || item.text === 'Мои данные' && 'needMergeAccounts' in window && window.needMergeAccounts) {
                    aContent += `<span class="header-acc-drop-ul__li-a-label">!</span>`
                }

                a.innerHTML = aContent;
                li.appendChild(a);

                ul.appendChild(li);
            });

            wrap.appendChild(ul);

            return $("body").append($(wrap)).find("." + dropSelectorClass);
        }

        function calcAccDropPos ($block, $drop) {

            if (!$block || $block.length === 0) return false;
            if (!$drop || $drop.length === 0) return false;

            // минимальный отступ от края экрана
            const minOffset = 20;

            // ширины
            const windowWidth = window.innerWidth;
            const blockWidth = $block.outerWidth();
            const dropWidth = $drop.outerWidth();
            const widthDelta = Math.abs(dropWidth - blockWidth);

            // позиция по вертикали
            const offsetFromBlock = ( $drop.hasClass("_fixed")) ? 0 : 15; // задаём вручную (можно корректировать при необходимости)

            const dropRect = $drop[0].getBoundingClientRect();
            const dropOffset = dropRect.top;

            if (dropOffset < 0) {
                $drop.removeClass("_active");
                return;
            }

            let element = $block[0];
            let posTop = 0;
            while (element) {
                posTop += element.offsetTop;
                element = element.offsetParent;
            }
            posTop += $block[0].offsetHeight + offsetFromBlock;

            // позиция левого края по горизонтали
            let posLeft;
            let blockPosLeft = $block.position().left;

            if (dropWidth > blockWidth) {
                posLeft = blockPosLeft - (widthDelta / 2);
            } else if (dropWidth < blockWidth) {
                posLeft = blockPosLeft + (widthDelta / 2);
            } else {
                posLeft = blockPosLeft;
            }

            // если вылезает за левый край
            if (posLeft <= minOffset) {
                posLeft = minOffset;
            } else { // предполагаем, что дроп не будет шире окна и не вылезет за оба края :)

                // позиция правого края по горизонтали
                const posRight = posLeft + dropWidth;

                // если вылезает за правый край
                if (posRight >= ( windowWidth - minOffset )) {
                    posLeft = windowWidth - (dropWidth + minOffset);
                }
            }

            $drop.css({
                top: posTop + "px",
                left: posLeft + "px"
            });
        }

        function startDropTimer ($drop) {
            return setTimeout(function () {
                $drop.removeClass("_active");
            }, 2500);
        }

        /**
         * Пункт "Корзина"
         */
        const $basket = $('.js-header-acc-basket-title');
        $basket.each(function() {
            const $_this = $ (this);
            const countBasket = $_this.data('count-item-basket');
            const $basketLabel = $_this.find('.js-header-acc-desktop__item-label-basket');
            let titleText = 'У вас нет товаров в корзине';

            if (countBasket && countBasket > 0) {
                titleText = `У вас ${globalFunctions.declension(countBasket, ['товар','товара','товаров'], true)} в корзине`;
            }

            $_this.attr('title', titleText);

            basketChangeCounter (countBasket);

            $(document).on("basketItemChange", (e, id, offerId, q, data) => {
                let itemsCount = 0
                for (const [key, value] of Object.entries(data.types)) {
                    itemsCount += parseInt(value.count)
                }
                basketChangeCounter (itemsCount);
            });

            function basketChangeCounter (counterValue) {
                if (counterValue > 0) {
                    $basketLabel.text (counterValue);
                    $basketLabel.addClass ('header__personal-item-label_visible');

                    titleText = `У вас ${globalFunctions.declension (counterValue, ['товар', 'товара', 'товаров'], true)} в корзине`;
                    $_this.attr ('title', titleText);
                } else {
                    $basketLabel.removeClass ('header__personal-item-label_visible');
                    $_this.attr ('title', 'У вас нет товаров в корзине')
                }
            }

            $ (document).on ("basketClean", (e) => {
                $basketLabel.text (0);
                $basketLabel.addClass ('header__personal-item-label_visible');
                $_this.attr ('title', 'У вас нет товаров в корзине');
            });
        });

        /**
         * Пункт "Избранное"
         */
        const $fav = $('.js-header-acc-desktop-item-fav');
        const countFav = $fav.data('count-fav');
        // todo в другое место
        window.countFav = countFav;
        const $favLabel = $fav.find('.js-header-acc-desktop__item-label-fav');
        let titleText =  $fav.attr('title') ? $fav.attr('title') : 'У вас нет товаров в избранном';

        if (countFav && countFav > 0) {
            titleText = `У вас ${globalFunctions.declension(countFav, ['товар','товара','товаров'], true)} в избранном`;
        }

        if ($favLabel.html() > 0) {
            $favLabel.addClass('header__personal-item-label_visible');
        }

        $fav.attr('title', titleText)

        $ (document).on ('is:added', function (e, bookId, offerId, url, countItems) {
            $favLabel.text(countItems);
            $favLabel.addClass('header__personal-item-label_visible');

            titleText = `У вас ${globalFunctions.declension(countItems, ['товар','товара','товаров'], true)} в избранном`;
            $fav.attr('title', titleText);
        });

        $ (document).on ('is:deleted', function (e, bookId, offerId, countItems) {
            if (parseInt(countItems) === 0) {
                $favLabel.removeClass('header__personal-item-label_visible');
                $fav.attr('title', 'У вас нет товаров в избранном')
            }
            else {
                $favLabel.text(countItems);
                titleText = `У вас ${globalFunctions.declension(countItems, ['товар','товара','товаров'], true)} в избранном`;
                $fav.attr('title', titleText);
            }
        });

        /**
         * Плашка с ворнингом в шапке
         */
        $ ('.js-banner-alert').each ((i, elem) => {
            const $_this = $ (elem);
            const alertId = $_this.data('alertId');
            if (localStorage.getItem ('headWarningClosed' + alertId) !== '1') {
                $_this.addClass ('banner-alert_shown');
                document.body.classList.add('body_global-hasTopBannerAlert');
                const event = new CustomEvent('banner.alert.shown', {
                    bubbles: true,
                    cancelable: true
                });
                elem.dispatchEvent(event);
            }
            $_this.find ('.js-banner-alert__close').on ('click', (e) => {
                e.preventDefault ();
                localStorage.setItem ('headWarningClosed' + alertId, '1');
                $_this.removeClass ('banner-alert_shown');
                document.body.classList.remove('body_global-hasTopBannerAlert');
                const event = new CustomEvent('banner.alert.hidden', {
                    bubbles: true,
                    cancelable: true
                });
                elem.dispatchEvent(event);
            });
        });
        
        // Баннер-растяжка над шапкой
        const bannerHeader = document.querySelector('.js-banner-header');
        if (bannerHeader) {
            document.body.classList.add('body_global-hasTopBannerAdvert');
        }
        
        
        // Ссылка на предыдущую страницу
        const prevHTML =
            `<div class="header__prev">
                <div class="header__prev-container">
                    <span class="header__prev-text js-banner-prev">Предыдущая страница</span>
                </div>
            </div>`;
        
        if (window.location.pathname.startsWith('/catalog/book-') && history.length > 1) {
            window.Header._node.insertAdjacentHTML('beforeend', prevHTML);
        }
        
        document.addEventListener('click', event => {
            if (event.target.closest('.js-banner-prev') && history.length > 1) {
                history.back();
            }
        })
        
        
        // Нижний бар
        
        window.bottomBar = {
            methods: {
                getPositionTop: function () {
                    let pos = 0;
                    const bar = document.querySelector('.js-nav-bottom');
                    if (bar) {
                        pos = window.innerHeight - bar.getBoundingClientRect().bottom + bar.offsetHeight;
                    }
                    return pos;
                }
            }
        };
        
        $(function () {
            // Не показываем в деталках товара, корзине и в процессе оформления заказа
            if (window.location.pathname.startsWith('/catalog/book-') 
                || window.location.pathname.startsWith('/personal/basket/')
                || window.location.pathname.startsWith('/personal/order/')
                || (window.location.pathname.startsWith('/lectorii/') && !window.location.pathname.endsWith('/lectorii/'))
            )
            {
                return false;
            }
            
            $(document).on('click', '.js-nav-bottom__item', (event) => {
                let doPrevent = false;
                const $item = $(event.target).closest('.js-nav-bottom__item');
                switch($item[0].dataset.itemCode) {
                    case 'home':
                        if ($item[0].classList.contains('nav-bottom__item_active')) {
                            doPrevent = true;
                        }
                        break;
                    
                    case 'catalog':
                        if (!$item[0].classList.contains('nav-bottom__item_active')) {
                            window.Header.methods.openCatalogMobile();
                        } else {
                            window.Header.methods.closeCatalogMobile();
                        }
                        doPrevent = true;
                        break;
                    
                    case 'basket':
                        if ($item[0].classList.contains('nav-bottom__item_active')) {
                            doPrevent = true;
                        }
                        break;
                    
                    case 'favourites':
                        if (!user.userLogged) {
                            $(document).trigger('needShow:popupLogin');
                            doPrevent = true;
                        }
                        break;
                    
                    case 'account':
                        if (!$item[0].classList.contains('nav-bottom__item_active')) {
                            window.Header.methods.openAccountMenu();
                        } else {
                            window.Header.methods.closeAccountMenu();
                        }
                        doPrevent = true;
                        break;
                    
                    default:
                        break;
                }
                
                if (doPrevent) {
                    event.stopPropagation();
                    event.preventDefault();
                }
            });
            
            // Пункт меню по каталогу
            
            document.addEventListener('menu.catalog.open', (event) => {
                const menuItemsCatalog = document.querySelectorAll('.js-nav-bottom__item[data-item-code="catalog"]');
                menuItemsCatalog.forEach(element => {
                    element.classList.add('nav-bottom__item_active');
                });
            });
            
            document.addEventListener('menu.catalog.close', (event) => {
                if (window.isMobileCatalogRootOpen || window.isMobileCatalogCategoryOpen)
                    return false;
                
                const menuItemsCatalog = document.querySelectorAll('.js-nav-bottom__item[data-item-code="catalog"]');
                menuItemsCatalog.forEach(element => {
                    element.classList.remove('nav-bottom__item_active');
                });
            });
            
            // Пункт меню по аккаунту
            
            document.addEventListener('menu.account.open', (event) => {
                const menuItemsAccount = document.querySelectorAll('.js-nav-bottom__item[data-item-code="account"]');
                menuItemsAccount.forEach(element => {
                    element.classList.add('nav-bottom__item_active');
                });
            });
            
            document.addEventListener('menu.account.close', (event) => {
                const menuItemsAccount = document.querySelectorAll('.js-nav-bottom__item[data-item-code="account"]');
                menuItemsAccount.forEach(element => {
                    element.classList.remove('nav-bottom__item_active');
                });
            });
            
            const navBottomHTML =
                `<div class="site-bottom-wrapper__nav-bottom">
                <div class="nav-bottom js-nav-bottom">
                    <a href="/" class="nav-bottom__item${(window.location.pathname === '/') ? ' nav-bottom__item_active' : ''} js-nav-bottom__item" data-item-code="home">
                        <span class="nav-bottom__item-icon">
                            <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 16.5V9.243a3 3 0 0 0-.879-2.122l-5.414-5.414a2.414 2.414 0 0 0-3.414 0L2.879 7.121A3 3 0 0 0 2 9.243V16.5A1.5 1.5 0 0 0 3.5 18h2A1.5 1.5 0 0 0 7 16.5V13a3 3 0 1 1 6 0v3.5a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5z" stroke="currentColor" stroke-width="2"/></svg>
                        </span>
                        <span class="nav-bottom__item-text">Главная</span>
                    </a>
                    <a href="javascript:;" class="nav-bottom__item js-nav-bottom__item" data-item-code="catalog">
                        <span class="nav-bottom__item-icon">
                            <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-5a5 5 0 1 0 2.757 9.172l2.536 2.535a1 1 0 0 0 1.414-1.414l-2.535-2.536A5 5 0 0 0 13 0zM1 16a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H1zM1 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2H1zm0 6a1 1 0 1 0 0 2h6.708a1 1 0 1 0 0-2H1z" fill="currentColor"/></svg>
                        </span>
                        <span class="nav-bottom__item-text">Каталог</span>
                    </a>
                    <a href="/personal/basket/" class="nav-bottom__item${(window.location.pathname.startsWith('/personal/basket/')) ? ' nav-bottom__item_active' : ''} js-nav-bottom__item" data-item-code="basket">
                        <span class="nav-bottom__item-icon">
                            <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 5a3 3 0 1 1 6 0v2H7V5zM5 7V5a5 5 0 1 1 10 0v2h4a1 1 0 0 1 .98 1.196l-1.517 7.588A4 4 0 0 1 14.54 19H5.459a4 4 0 0 1-3.922-3.216L.02 8.197A1 1 0 0 1 1 7h4zm-1.502 8.392L2.22 9h15.56l-1.278 6.392A2 2 0 0 1 14.54 17H5.459a2 2 0 0 1-1.96-1.608z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
                        </span>
                        <span class="nav-bottom__item-text">Корзина</span>
                        <span class="nav-bottom__item-count js-nav-bottom__item-count">0</span>
                    </a>
                    <a href="${(user.userLogged) ? '/personal/favorites/' : 'javascript:;'}" class="nav-bottom__item js-nav-bottom__item" data-item-code="favourites">
                        <span class="nav-bottom__item-icon">
                            <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 7a6 6 0 0 1 10-4.472A6 6 0 0 1 20 7c0 2.099-1.177 4.325-2.859 6.33-1.706 2.035-4.046 3.979-6.626 5.528a1 1 0 0 1-1.03 0c-2.58-1.55-4.92-3.493-6.626-5.528C1.177 11.325 0 9.1 0 7zm6-4a4 4 0 0 0-4 4c0 1.401.823 3.175 2.391 5.045C5.825 13.754 7.79 15.433 10 16.826c2.21-1.393 4.175-3.072 5.609-4.781C17.177 10.175 18 8.4 18 7a4 4 0 0 0-7.2-2.4 1 1 0 0 1-1.6 0A3.992 3.992 0 0 0 6 3z" fill="currentColor"/></svg>
                        </span>
                        <span class="nav-bottom__item-text">Избранное</span>
                        <span class="nav-bottom__item-count js-nav-bottom__item-count">0</span>
                    </a>
                    <a href="javascript:;" class="nav-bottom__item js-nav-bottom__item" data-item-code="account">
                        <span class="nav-bottom__item-icon">
                            <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.818 19.731c-3.902-3.641-9.734-3.641-13.636 0a1 1 0 0 1-1.364-1.462c4.67-4.359 11.694-4.359 16.364 0a1 1 0 0 1-1.364 1.462z" fill="currentColor"/><mask id="b" fill="#fff"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 2a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z"/></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M10 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 2a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z" fill="currentColor"/><path d="M12.5 6.5A2.5 2.5 0 0 1 10 9v4a6.5 6.5 0 0 0 6.5-6.5h-4zM10 4a2.5 2.5 0 0 1 2.5 2.5h4A6.5 6.5 0 0 0 10 0v4zM7.5 6.5A2.5 2.5 0 0 1 10 4V0a6.5 6.5 0 0 0-6.5 6.5h4zM10 9a2.5 2.5 0 0 1-2.5-2.5h-4A6.5 6.5 0 0 0 10 13V9zm4.5-2.5A4.5 4.5 0 0 1 10 11v4a8.5 8.5 0 0 0 8.5-8.5h-4zM10 2a4.5 4.5 0 0 1 4.5 4.5h4A8.5 8.5 0 0 0 10-2v4zM5.5 6.5A4.5 4.5 0 0 1 10 2v-4a8.5 8.5 0 0 0-8.5 8.5h4zM10 11a4.5 4.5 0 0 1-4.5-4.5h-4A8.5 8.5 0 0 0 10 15v-4z" fill="currentColor" mask="url(#b)"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
                        </span>
                        <span class="nav-bottom__item-text">Кабинет</span>
                        <span class="nav-bottom__item-count js-nav-bottom__item-count">0</span>
                    </a>
                </div>
            </div>`;
            
            document.body.insertAdjacentHTML('beforeend', navBottomHTML);
            $('body').addClass('body_has-bottom-nav');
            
            const updateBadge = function(itemCode, value) {
                const counters = document.querySelectorAll('.js-nav-bottom__item[data-item-code="'+itemCode+'"] .js-nav-bottom__item-count');
                counters.forEach(element => {
                    element.textContent = value;
                    if (value > 0) {
                        element.classList.add('nav-bottom__item-count_visible');
                    } else {
                        element.classList.remove('nav-bottom__item-count_visible');
                    }
                });
            }
            
            // Реакция счётчика на изменение корзины
            $(document).on("basketItemChange", (e, id, offerId, q, data) => {
                let itemsCount = 0;
                for (const [key, value] of Object.entries(data.types)) {
                    itemsCount += parseInt(value.count);
                }
                window.globalHeaderData.counters.basket = parseInt(itemsCount);
                updateBadge('basket', window.globalHeaderData.counters.basket);
            });
            
            // Реакция счётчика на изменение избранного
            $ (document).on ('is:added', function (e, bookId, offerId, url, countItems) {
                window.globalHeaderData.counters.favourites = parseInt(countItems);
                updateBadge('favourites', parseInt(window.globalHeaderData.counters.favourites));
            });
            $ (document).on ('is:deleted', function (e, bookId, offerId, countItems) {
                window.globalHeaderData.counters.favourites = parseInt(countItems);
                updateBadge('favourites', parseInt(window.globalHeaderData.counters.favourites));
            });
            
            // Инит на загрузке
            updateBadge('basket', parseInt(window.globalHeaderData.counters.basket));
            updateBadge('favourites', parseInt(window.globalHeaderData.counters.favourites)); 
        });
    });
}());
